var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondiscussionssendMessage = function SvgIcondiscussionssendMessage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/discussions.send_message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/discussions.send_message",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse-4",
    fill: "#09BE86",
    fillRule: "nonzero",
    transform: "translate(15.000000, 15.000000) rotate(-90.000000) translate(-15.000000, -15.000000) ",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.151,15.3640945 L11.151,15.3390945 L11.126,15.3390945 L11.126,15.3130945 L11.1,15.3130945 L11.1,15.2870945 L11.076,15.2630945 L11.076,15.2380945 L11.05,15.2380945 L11.05,15.2130945 L11.05,15.1870945 L11.025,15.1870945 L11.025,15.1630945 L11.025,15.1370945 L11.025,15.1120945 L11,15.1120945 L11,15.0870945 L11,15.0620945 L11,15.0370945 L11,15.0120945 L11,14.9870945 L11,14.9610945 L11,14.9360945 L11,14.9110945 L11,14.8870945 L11.025,14.8620945 L11.025,14.8360945 L11.025,14.8100945 L11.05,14.7870945 L11.05,14.7600945 L11.075,14.7350945 L11.075,14.7100945 L11.1,14.7100945 L11.1,14.6870945 L11.125,14.6620945 L11.15,14.6370945 L14.632,11.1370945 C14.8356018,10.949168 15.151157,10.9551581 15.3474799,11.1506764 C15.5438028,11.3461947 15.5510888,11.6617226 15.364,11.8660945 L12.766,14.4870945 L18.495,14.4870945 C18.7719628,14.4870809 18.9972578,14.7101453 19,14.9870945 C19.0009029,15.2683086 18.7808463,15.5006883 18.5,15.5150945 L12.766,15.5150945 L15.366,18.1060945 C15.5055411,18.2348924 15.5632422,18.4298224 15.5162923,18.6138232 C15.4693425,18.7978241 15.3252994,18.9412769 15.1411073,18.9874707 C14.9569151,19.0336645 14.7622237,18.9751634 14.634,18.8350945 L11.151,15.3640945 Z",
    id: "Path_407",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(15.000001, 15.001507) rotate(-270.000000) translate(-15.000001, -15.001507) "
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondiscussionssendMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.discussions.send_message.acd7b8b8eea1a5a76bb55f962eb11605.svg";